<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    :title="`${DocumentStatus}报价`"
    width="100%"
    height="100%"
    @show="showModal"
  >
    <div class="formContainer">
      <div class="leftFormContainer">
        <el-form ref="FormRef" size="mini" :rules="rules" :model="form" :disabled="isDisabled">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="企业名称" prop="customer_name">
                <el-autocomplete
                  v-model="form.customer_name"
                  :fetch-suggestions="querySearchCustomerName"
                  placeholder="输入"
                  clearable
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="项目名称" prop="project_name">
                <el-input placeholder="输入" v-model="form.project_name" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="需求日期" prop="requirement_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.requirement_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="需求概述" prop="requirement_content">
                <el-input type="textarea" :rows="3" placeholder="输入" v-model="form.requirement_content" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!-- <el-col :span="form.document_status === 9 ? 12 : 24"> -->
            <el-col :span="form.document_status === 9 ? 8 : 12">
              <el-form-item label="内部价格(元)" prop="proposal_quotation">
                <el-input placeholder="自动计算" v-model="form.proposal_quotation" v-money:2="showMoney" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="form.document_status === 9 ? 8 : 12">
              <el-form-item label="对外报价(元)" prop="outward_quotation">
                <el-input placeholder="输入" v-model="form.outward_quotation" v-money:2="showMoney" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.document_status === 9">
              <el-form-item label="审批报价(元)" prop="final_quotation">
                <el-input placeholder="关联获取" v-model="form.final_quotation" v-money:2="showMoney" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <!--          <el-row :gutter="10">-->
          <!--            <el-col :span="6">-->
          <!--              <el-form-item label="合同状态" prop="contractState">-->
          <!--                <el-input placeholder="关联获取" v-model="form.contractState" disabled />-->
          <!--              </el-form-item>-->
          <!--            </el-col>-->
          <!--            <el-col :span="18">-->
          <!--              <el-form-item label="支付情况" prop="contractPayState">-->
          <!--                <el-input placeholder="关联获取" v-model="form.contractPavState" disabled />-->
          <!--              </el-form-item>-->
          <!--            </el-col>-->
          <!--          </el-row>-->

          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="建设周期" prop="construction_period">
                <el-input placeholder="输入" v-model="form.construction_period" />
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="备注" prop="memo">
                <el-input placeholder="输入" v-model="form.memo" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-show="form.document_status > 1">
            <el-col :span="24">
              <el-form-item label="总经理审批意见" prop="president_approve_opinions">
                <el-input type="textarea" :rows="3" readonly v-model="form.president_approve_opinions" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-show="form.document_status > 1">
            <el-col :span="24">
              <el-form-item label="领导审批意见" prop="leader_approve_opinions">
                <el-input type="textarea" :rows="3" readonly v-model="form.leader_approve_opinions" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div>
          <!-- 明细table -->
          <div style="margin-bottom: 5px" v-if="!isDisabled">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAddMore">新增多行</el-button>
          </div>
          <vxe-grid
            ref="xTable"
            size="mini"
            :height="tableMinHeight"
            :column-config="{ minWidth: '80px' }"
            :columns="tableColumns"
            border
            keep-source
            resizable
            :edit-rules="validRules"
            show-overflow
            :data="form.detailList"
            highlight-hover-row
            highlight-current-row
            :mouse-config="{ area: true, extension: true }"
            :edit-config="{ trigger: 'dblclick', mode: 'cell', activeMethod: activeMethod, showIcon: false }"
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              enterToTab: true,
              isClip: true,
              isEdit: true,
              editMethod: editMethod
            }"
            @edit-closed="editClosed"
            :clip-config="{
              pasteMethod: pasteMethod
            }"
            show-footer
            :footer-method="footerMethod"
            :menu-config="{ body: { options: bodyMenus } }"
            @cell-menu="cellContextMenuEvent"
          >
          </vxe-grid>
        </div>
      </div>
      <div class="rightFormContainer">
        <div class="rightFileListContainer">
          <FileList :ID="id" :isDisabled="isDisabled" ref="FileListRef" vuePath="QuotationApply" />
        </div>
        <div class="timeLineContainer">
          <YKDivider>
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; flex: none">
              <div>单据日志</div>
            </div>
          </YKDivider>
          <div class="timeLineDataContainer">
            <div class="emptyFile" v-if="form.timeLine.length === 0">
              <div>
                <img src="../../assets/img/null-data.png" />
                <div>- 暂无数据 -</div>
              </div>
            </div>

            <div class="logItemContainer" v-else>
              <div class="logItem" v-for="(item, index) in form.timeLine" :key="index">
                <div class="logItemTitle">
                  <div>
                    <span style="color: rgb(108, 158, 255)">{{ `${index + 1}. ` }}</span>
                    <span style="font-weight: bold">{{ item.operator }}</span>
                  </div>

                  <div style="flex: 1; text-align: right">{{ ykDateFormat('yyyy-MM-dd HH:mm', item.logTime) }}</div>
                </div>
                <div class="logItemContent">
                  <div>{{ item.logContent }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FastInputVue
      ref="FastInputVueRef"
      :modalTitle="fastInputType === 'refuse' ? '驳回' : '审批'"
      @sureBack="sureBackApprovalOpinions"
    />
    <FastInputFinal ref="FastInputFinalRef" @sureBack="sureBackApprovalFinalOpinions" />

    <DetailModalBtnVue
      ref="DetailModalBtnVueRef"
      menuPath="QuotationApply"
      :refuseLabel="'驳回'"
      :parentData="this"
      @handleClick="handleClickBtn"
    />

    <ExportInfoModal ref="ExportInfoModalRef" @sure="sureExport" />
  </vxe-modal>
</template>
<script>
import FileList from '@/components/Form/FileList.vue'
import DetailModalBtnVue from '@/components/common/DetailModalBtn.vue'
import { getState } from '../../utils/state'
import FastInputVue from '../../components/Modal/FastInput/FastInput.vue'
import FastInputFinal from './FastInput.vue'
import YKDivider from '../../components/common/YKDivider.vue'
import { calculate } from '../../utils/computed'
import ExportInfoModal from './ExportInfoModal.vue'
import fileSaver from 'file-saver'
import docx from 'html-docx-js/dist/html-docx'

export default {
  components: {
    FileList,
    FastInputVue,
    DetailModalBtnVue,
    FastInputFinal,
    YKDivider,
    ExportInfoModal
  },
  data() {
    return {
      id: -1,
      // 表单
      form: {
        contractId: 0,
        id: 0,
        manager_review: true,
        creator_id: 0,
        creator: '',
        createTime: '',
        dept_name: '',
        customer_name: '',
        project_name: '',
        requirement_date: '',
        requirement_content: '',
        construction_period: '',
        memo: '',
        proposal_quotation: 0,
        outward_quotation: 0,
        president_approve_opinions: '',
        leader_approve_opinions: '',
        final_quotation: 0,
        document_status: 0,
        last_modify_time: '',
        contractState: '',
        contractPavState: '',
        timeLine: [],
        detailList: []
      },
      rules: {
        customer_name: [
          { required: true, message: '请输入企业名称', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        project_name: [
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        requirement_date: [{ required: true, message: '请输入需求日期', trigger: 'change' }],
        requirement_content: [{ required: true, message: '请输入需求内容', trigger: 'change' }],
        construction_period: [
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        memo: [
          {
            min: 0,
            max: 1024,
            message: '长度在 0 到 1024 个字符',
            trigger: 'change'
          }
        ],
        proposal_quotation: [
          // { required: true, message: '请输入建议报价(元)', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 12,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        outward_quotation: [
          // { required: true, message: '请输入建议报价(元)', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 12,
            decimalLength: 2,
            trigger: 'change'
          },
          { validator: this.validOutwardQuotation, trigger: 'change' }
        ]
      },
      validRules: {
        features: [
          { required: true, message: '请输入需求点', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        requirement_content: [
          {
            min: 0,
            max: 2048,
            message: '长度在 0 到 2048 个字符',
            trigger: 'change'
          }
        ],
        dev_hours: [
          // { required: true, message: '请输入开发工时', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        testing_hours: [
          // { required: true, message: '请输入测试工时', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        quoted_dev_hours: [
          // { required: true, message: '请输入报价开发工时', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        quoted_testing_hours: [
          // { required: true, message: '请输入报价测试工时', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        price: [
          // { required: true, message: '请输入单价', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 8,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        quoted_amount: [
          { required: true, message: '请输入报价金额', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 15,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        memo: [
          {
            min: 0,
            max: 1024,
            message: '长度在 0 到 1024 个字符',
            trigger: 'change'
          }
        ]
      },
      formVisible: false,

      showMoney: true,
      // 是否禁用编辑
      isDisabled: false,
      // 快速输入
      quickSelectCustomerName: [],
      // table快捷键
      bodyMenus: [
        [
          {
            code: 'selectTotal',
            name: '拉选合计'
          }
        ]
      ],
      // 快速输入框类型
      fastInputType: ''
    }
  },
  methods: {
    // 导出word
    export() {
      this.$refs.ExportInfoModalRef.openModal()
    },
    // 确认导出
    sureExport(form) {
      let supplierLineStr = `供方: ${form.supplier}联系人: ${form.supplierContact}联系方式: ${form.supplierTel}`
      let requiredLineStr = `需方: ${form.required}联系人: ${form.requiredContact}联系方式: ${form.requiredTel}`

      // 计算每个字符串的宽度，考虑一个中文字符等于 11/3 个字符
      function getStringWidth(str) {
        return str.split('').reduce((width, char) => {
          const code = char.charCodeAt(0)
          if (code >= 0x4e00 && code <= 0x9fff) {
            return width + 11 / 3 // 中文字符宽度为 11/3
          } else {
            return width + 1 // 英文字符宽度为 1
          }
        }, 0)
      }

      // 提取“联系人”前面的部分
      const supplierContactPrefix = supplierLineStr.split('联系人:')[0]
      const requiredContactPrefix = requiredLineStr.split('联系人:')[0]

      // 计算“联系人”前面的最长宽度
      const maxContactPrefixWidth = Math.max(
        getStringWidth(supplierContactPrefix),
        getStringWidth(requiredContactPrefix)
      )

      // 计算填充空格的函数
      function padToWidth(str, width) {
        let currentWidth = getStringWidth(str)
        while (currentWidth < width) {
          str += ' '
          currentWidth = getStringWidth(str)
        }
        return str
      }

      // 根据最长的“联系人”前面部分宽度，填充空格
      const alignedSupplierContactPrefix = padToWidth(supplierContactPrefix, maxContactPrefixWidth)
      const alignedRequiredContactPrefix = padToWidth(requiredContactPrefix, maxContactPrefixWidth)

      // 提取“联系方式”前面的部分
      const supplierContactStr = `联系人: ${supplierLineStr.split('联系人:')[1].split('联系方式:')[0]}`
      const requiredContactStr = `联系人: ${requiredLineStr.split('联系人:')[1].split('联系方式:')[0]}`

      // 计算“联系方式”前面的最长宽度
      const maxContactWidth = Math.max(getStringWidth(supplierContactStr), getStringWidth(requiredContactStr))

      // 根据最长的“联系方式”前面部分宽度，填充空格
      const alignedSupplierContactStr = padToWidth(supplierContactStr, maxContactWidth)
      const alignedRequiredContactStr = padToWidth(requiredContactStr, maxContactWidth)

      // 提取“联系方式”后的部分
      const supplierPhoneStr = `联系方式: ${supplierLineStr.split('联系方式:')[1]}`
      const requiredPhoneStr = `联系方式: ${requiredLineStr.split('联系方式:')[1]}`

      // 重新组装对齐后的字符串
      let spacePre = ''
      for (let i = 0; i < 21; i++) {
        spacePre += '&nbsp;'
      }
      let spaceNext = ''
      for (let i = 0; i < 16; i++) {
        spaceNext += '&nbsp;'
      }
      let alignedSupplierLineStr = `${alignedSupplierContactPrefix}${spacePre}${alignedSupplierContactStr}${spaceNext}${supplierPhoneStr}`
      let alignedRequiredLineStr = `${alignedRequiredContactPrefix}${spacePre}${alignedRequiredContactStr}${spaceNext}${requiredPhoneStr}`

      alignedSupplierLineStr = alignedSupplierLineStr.replaceAll(' ', '&nbsp;')
      alignedRequiredLineStr = alignedRequiredLineStr.replaceAll(' ', '&nbsp;')

      // <div class="left">供方: ${form.supplier}</div>
      // <div class="middle">联系人: ${form.supplierContact}</div>
      // <div class="right">联系方式: ${form.supplierTel}</div>

      // <div class="left">需方: ${form.required}</div>
      // <div class="middle">联系人: ${form.requiredContact}</div>
      // <div class="right">联系方式: ${form.requiredTel}</div>
      const exportHTML = `
	<div class="printContainer">
			<style>
				.printContainer {
					width: 100%;
					font-size: 14px;
				}

				.printTitle {
					width: 100%;
					text-align: center;

					margin-top: 5px;
					margin-bottom: 10px;
				}

				.printTitle span {
					font-size: 20px;
          font-weight: bold;
          font-family: '等线';
				}

				.printTableHead {
          width: 100%
				}

        .printTableHead div {
          font-weight: bold;
          font-size: 14px;
          font-family: '等线';
        }

				.printTableHeadTr {
					font-weight: bold;
          font-size: 14px;
          font-family: '等线';
        }

				.printTableFooter {
					width: 100%;
					font-weight: bold;
				}
        .printTableFooter div {
          font-size: 14px;
          font-family: '等线';
        }

				table {
					table-layout: fixed;
					border-collapse: collapse;
					border: 1px solid black;
					width: 100%;
				}

				/* 可选：为表格的每个单元格添加边框 */
				table th,
				td {
					/* 单元格边框颜色为黑色 */
					border: 1px solid black;
					/* 允许在单词内断行 */
					word-break: break-all;
					/* 允许长单词或数字换行 */
					overflow-wrap: break-word;

					text-align: center;

					box-sizing: border-box;
					padding: 0px 2px;

          font-size: 14px;
          font-family: '等线';
				}

				table td {
					font-weight: 100;
				}
			</style>

			<div class="printTitle">
				<span>报价单</span>
			</div>

			<div class="printTableHead">
				<div class="printTableHeadTr">
          ${alignedSupplierLineStr}
        </div>
				<div class="printTableHeadTr">
          ${alignedRequiredLineStr}
        </div>
				<div>项目名称: ${this.form.project_name}</div>
			</div>
			<br />

			<div class="printTable">
				<table>
					<tr>
						<th style="width: 9%;">序号</th>
						<th style="width: 14%;">需求内容</th>
						<th style="width: 51%;text-align: center;">需求详情</th>
						<th style="width: 13%;">报价(元)</th>
						<th style="width: 13%;">备注</th>
					</tr>
          ${this.form.detailList
            .map((item, index) => {
              return `<tr>
                  <td>${calculate(`${index}+1`)}</td>
                  <td>${item.requirement_content}</td>
                  <td style="text-align: left;">${item.features}</td>
                  <td style="font-family: '宋体';">${this.$utils.commafy(parseFloat(item.quoted_amount), {
                    digits: 2
                  })}</td>
                  <td>${item.memo}</td>
                </tr>`
            })
            .join('')}
					<tr>
						<td colspan="3" style="text-align: left; font-weight: bold;padding:0 5px;">
							合计
							<br />
							金额（小写）单位：元
						</td>
						<td colspan="2" style="text-align: left;font-weight: bold;font-family: '宋体';padding-left: 10px;">￥ ${this.$utils.commafy(
              parseFloat(this.form.outward_quotation),
              { digits: 2 }
            )}</td>
					</tr>
					<tr>
						<td style="font-weight: bold;text-align: left;padding:0 5px;">
							建设周期
						</td>
						<td colspan="4" style="text-align: left; ">
							${this.form.construction_period}
						</td>
					</tr>
					<tr>
						<td style="font-weight: bold;text-align: left;padding:0 5px;">备注</td>
						<td colspan="4" style="text-align: left; ">
							${this.form.memo}
						</td>
					</tr>
				</table>
			</div>

			<br />
			<div class="printTableFooter">
				<div>报价日期: ${this.ykDateFormat('yyyy年MM月dd日', form.quotationDate)}</div>
				<div>报价有效期: ${form.validityPeriod}</div>
				<div>报价供应商（盖章）: </div>
				<div>统一社会信用代码（营业执照编号）: ${form.creditCode}</div>
				<div>住所: ${form.address}</div>
				<div>法定代表人: ${form.legalRepresentative}</div>
			</div>
		</div>
`

      const converted = docx.asBlob(exportHTML, {
        orientation: 'landscape'
      })
      fileSaver.saveAs(converted, `${this.form.customer_name}项目报价单.docx`)
    },
    validOutwardQuotation(rule, value, callback) {
      if (this.form.outward_quotation < this.form.proposal_quotation) {
        callback(new Error('对外价格不可小于内部价格!'))
      }
      callback()
    },
    // 提交
    submit() {
      this.$confirm('提交后不可撤销, 是否确定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureSubmit()
        if (success) {
          this.$message.success('操作成功!')
          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 确认提交
    async sureSubmit() {
      const { data: res } = await this.$http.put(`/Finance/Quotation_apply/submit/${this.id}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 单元格右键被点击事件
    async cellContextMenuEvent({ $table }) {
      const that = this
      const a = $table.getCellAreas()
      if (a) {
        const total = that.tableSelectTotal(a)
        that.bodyMenus[0][0].children = []
        that.bodyMenus[0][0].children.push({ code: 'total', name: total })
      }
    },
    // 表尾函数
    footerMethod({ columns, data }) {
      const that = this
      const sums = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('合计')
        } else {
          let sumCell = null
          switch (column.property) {
            case 'quoted_amount':
              sumCell = that.$utils.commafy(that.$utils.sum(data, column.property), { digits: 2 })
              break
            case 'dev_hours':
            case 'testing_hours':
            case 'dev_hours_sum':
            case 'quoted_dev_hours':
            case 'quoted_testing_hours':
            case 'quoted_hours_sum':
              sumCell = this.$utils.sum(data, column.property)
              break
          }

          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    },
    // 粘贴方法
    pasteMethod({ row, column, cellValue }) {
      if (this.isDisabled) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }

      // 报价金额列单独处理 - 如果修改报价金额, 但是报价合计大于0, 则不允许修改
      if (column.property === 'quoted_amount' && row['quoted_hours_sum'] > 0) {
        return false
      }

      if (column.editRender?.name && ['input', '$input'].includes(column.editRender.name)) {
        row[column.property] = cellValue

        this.editClosed({ row, column })
      }
    },
    editClosed({ row, column }) {
      if (['dev_hours', 'testing_hours'].includes(column.property)) {
        // 计算开发合计
        row['dev_hours_sum'] = calculate(`${row['dev_hours']}+${row['testing_hours']}`)
      }

      if (['quoted_dev_hours', 'quoted_testing_hours', 'price'].includes(column.property)) {
        // 计算报价合计
        row['quoted_hours_sum'] = calculate(`${row['quoted_dev_hours']}+${row['quoted_testing_hours']}`)

        // 如果有报价合计才计算, 否则手填
        if (row['quoted_hours_sum'] > 0) {
          // 计算报价金额
          row['quoted_amount'] = calculate(`(${row['quoted_hours_sum']}*${row['price']})&2`)
        }
      }

      // 计算建议报价
      const tableData = this.$refs.xTable.getTableData().fullData
      this.form.proposal_quotation = this.$utils.sum(tableData, 'quoted_amount')

      this.$refs.xTable.updateFooter()
    },
    // 新增行
    handleAdd() {
      this.$refs.xTable.insertAt({ price: 3000 }, -1)
    },
    // 新增N行
    handleAddMore() {
      this.$prompt('请输入需要增加的行数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[1-9]\d*$/,
        inputErrorMessage: '请输入正确的数值'
      })
        .then(({ value }) => {
          if (this.$utils.isInteger(value)) {
            for (let i = 0; i < value; i++) {
              this.$refs.xTable.insertAt({ price: 3000 }, -1)
            }
          } else {
            this.$message.error('请输入正确的数值')
          }
        })
        .catch(() => {})
    },
    // 最终节点输入完意见
    async sureBackApprovalFinalOpinions(options) {
      const { final_quotation, ApprovalOpinions } = options
      const flag = await this.sureReview(false, ApprovalOpinions, final_quotation)

      if (flag) {
        this.$message.success('操作成功!')

        this.$emit('updateData')
        this.BindText()

        this.$refs.FastInputFinalRef.closeModal()
      }
    },
    // 输入完意见
    async sureBackApprovalOpinions(options) {
      if (this.fastInputType === 'refuse') {
        const flag = await this.sureObsolete(options)

        if (flag) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()

          this.$refs.FastInputVueRef.closeModal()
        }
      } else {
        const flag = await this.sureReview(false, options)

        if (flag) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()

          this.$refs.FastInputVueRef.closeModal()
        }
      }
    },
    // 获取下拉框
    async handleGetSelectItem() {
      const { data: res } = await this.$http.get('/Finance/Quotation_apply/select-item')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.quickSelectCustomerName = res.data.filter(item => item.code === 'customer_name')
    },
    querySearchCustomerName(queryString, cb) {
      const quickSelectCustomerName = this.quickSelectCustomerName
      const results = queryString
        ? quickSelectCustomerName.filter(item => String(item.value).includes(queryString))
        : quickSelectCustomerName
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    // 拒绝
    refuse() {
      this.fastInputType = 'refuse'
      this.$refs.FastInputVueRef.openModal()
      // this.$confirm('是否确认驳回?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(async () => {
      //   const success = await this.sureObsolete()
      //   if (success) {
      //     this.$message.success('操作成功!')
      //     this.$emit('updateData')
      //     this.BindText()
      //   }
      // })
    },
    // 领导/总经理审批
    leaderReview() {
      // 林工审过了, 到姚总审, 可以改最终报价
      if (this.form.document_status === 2) {
        this.$refs.FastInputFinalRef.openModal(this.form.outward_quotation)
      } else {
        this.fastInputType = 'review'
        this.$refs.FastInputVueRef.openModal()
      }
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 调用审批接口
    async sureReview(flag = false, options = '', final_quotation = 0) {
      const { data: res } = await this.$http.put('/Finance/Quotation_apply/audit', [
        {
          id: this.id,
          manager_review: flag,
          approve_opinions: options,
          final_quotation
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/Finance/Quotation_apply/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete(options) {
      const { data: res } = await this.$http.put('/Finance/Quotation_apply/obsolete', [
        {
          id: this.id,
          manager_review: false,
          approve_opinions: options
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'submit':
          this.submit()
          break
        case 'del':
          this.del()
          break
        case 'unReview':
          this.unReview()
          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
        case 'export':
          this.export()
          break
      }
    },
    // 打开模态窗
    openModal(id = 0) {
      this.id = id

      if (!this.id) {
        this.form = {
          id: 0,
          manager_review: true,
          creator_id: 0,
          creator: '',
          createTime: '',
          dept_name: '',
          customer_name: '',
          project_name: '',
          requirement_date: '',
          requirement_content: '',
          proposal_quotation: 0,
          outward_quotation: 0,
          construction_period: '',
          memo: '',
          president_approve_opinions: '',
          leader_approve_opinions: '',
          final_quotation: 0,
          document_status: 0,
          last_modify_time: '',
          timeLine: [],
          detailList: []
        }
      }

      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    async validEnter() {
      const that = this
      let flag = true
      await that.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )

      that.errIndex = []
      that.removeEmptyForTable(that.$refs.xTable)
      const errMap = await that.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, column, rules } = params
            rules.forEach(() => {
              that.errIndex.push({
                _XID: row._XID,
                property: column.property
              })
            })
          })
        })
        if (that.errIndex.length > 0) {
          flag = false
        }
      }

      if (that.$refs.xTable.getTableData().tableData.length === 0) {
        that.$XModal.alert({
          message: that.messageConfig.blankDetail,
          status: 'warning'
        })
        return false
      }

      if (!flag) {
        that.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 获取数据
    async BindText() {
      const that = this
      if (that.id > 0) {
        const { data: res } = await that.$http.get('/Finance/Quotation_apply', {
          params: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.form = res.data
        }
      } else {
        this.form.requirement_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        // 用户信息赋值
        this.form.users_id = this.$store.state.userInfo.userId
        this.form.users_name = this.$store.state.userInfo.name

        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
      }
      that.$nextTick(() => {
        that.$refs.FormRef.clearValidate()

        if (this.form.document_status !== 0 || this.form.creator_id !== this.$store.state.userInfo.userId) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      })
    },
    // 新增
    async add() {
      const that = this
      let form = { ...that.form }
      let insertRecords = that.$refs.xTable.getInsertRecords()

      // 翻转
      insertRecords = Array.from(insertRecords).reverse()

      form.detailList = insertRecords
      form = that.removeObjectNull(form)
      form.detailList = that.removeArrayNull(form.detailList)
      const { data: res } = await that.$http.post('/Finance/Quotation_apply', form)
      if (res.isSuccess) {
        that.id = res.data
        that.$emit('updateData')

        this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件

        that.BindText()
        that.$message.success(that.messageConfig.save.success)
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 更新
    async update() {
      const that = this
      let form = { ...that.form }

      let insertRecords = that.$refs.xTable.getInsertRecords()

      // 翻转
      insertRecords = Array.from(insertRecords).reverse()

      let removeRecords = that.$refs.xTable.getRemoveRecords()
      let updateRecords = that.$refs.xTable.getUpdateRecords()
      form.detailList = []
      for (let item of insertRecords) {
        form.detailList.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailList.push(item)
      }
      for (let item of updateRecords) {
        form.detailList.push(item)
      }

      form = that.removeObjectNull(form)
      form.detailList = that.removeArrayNull(form.detailList)
      const { data: res } = await that.$http.put('/Finance/Quotation_apply', form)
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.save.success)
        that.$emit('updateData')

        that.BindText()
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 删除
    del() {
      const that = this
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.delete('/Finance/Quotation_apply', {
          data: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.$message.success(that.messageConfig.del.success)
          that.formVisible = false

          that.$emit('updateData')
        } else {
          that.$message.error(res.errorMessage)
        }
      })
    },
    async showModal() {
      await this.BindText()

      this.handleGetSelectItem()

      this.getFileList()
    },
    // cell激活控制
    activeMethod({ row, column }) {
      if (this.isDisabled) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      // 报价金额列单独处理 - 如果修改报价金额, 但是报价合计大于0, 则不允许修改
      if (column.property === 'quoted_amount' && row['quoted_hours_sum'] > 0) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (this.isDisabled) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      // 报价金额列单独处理 - 如果修改报价金额, 但是报价合计大于0, 则不允许修改
      if (column.property === 'quoted_amount' && row['quoted_hours_sum'] > 0) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    }
  },
  computed: {
    // 获取状态
    DocumentStatus() {
      if (this.id === 0) {
        return ''
      }

      return `[${getState(this.form, 'QuotationApply')}] `
    },
    tableColumns() {
      let tableColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        }
      ]

      // 禁用
      if (!this.isDisabled) {
        tableColumns.push({
          field: 'delete',
          title: '删除',
          width: '50',
          visible: this.isCanEdit,
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.removeRowForTable(row, this.$refs.xTable, this.$data)
                  }}
                ></i>
              ]
            }
          }
        })
      }

      tableColumns = [
        ...tableColumns,
        ...[
          {
            field: 'requirement_content',
            title: '需求内容',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'features',
            title: '需求点',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'dev_hours',
            title: '开发工时',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'testing_hours',
            title: '测试工时',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'dev_hours_sum',
            title: '开发合计工时'
          },
          {
            field: 'quoted_dev_hours',
            title: '报价开发工时',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'quoted_testing_hours',
            title: '报价测试工时',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'quoted_hours_sum',
            title: '报价合计工时'
          },
          {
            field: 'price',
            title: '单价',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'quoted_amount',
            title: '内部报价金额',
            formatter: ['formatAmount', '2', true],
            align: 'right',
            headerAlign: 'center',
            cellType: 'string',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'memo',
            title: '备注',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          }
        ]
      ]

      return tableColumns
    },
    // 表格最小高度
    tableMinHeight() {
      // *0.9
      const modalHeight = calculate(`(${this.$store.state.clientHeight})&0`)
      const formItemHieght = 75 // 单行表单高度
      const textareaHeight = 112 // 多行表单高度
      const headerHeight = 44
      const footerHeight = 71 // 底部按钮高度
      const paddingHeight = 22 + 10 // padding高度
      const tableBtnHeight = this.isDisabled ? 0 : 35 // table按钮高度
      const reservedHeight = 15 // 预留高度

      let tableMinHeight = calculate(
        `${modalHeight}-(${headerHeight}+${footerHeight}+${paddingHeight}+${tableBtnHeight})-(${formItemHieght}*3)-(${textareaHeight})-${reservedHeight}`
      )

      if (this.form.document_status > 1) {
        tableMinHeight = calculate(`${tableMinHeight}-(${textareaHeight}*2)`)
      }

      if (tableMinHeight <= 215) {
        tableMinHeight = ''
      } else {
        tableMinHeight = tableMinHeight + 'px'
      }

      return tableMinHeight
    }
  }
}
</script>
<style lang="less" scoped>
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  width: calc(100% - @rightFormContainerWidth);
  height: 100%;

  box-sizing: border-box;
  padding: 0 10px 10px 10px;

  overflow: auto;

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  width: @rightFormContainerWidth;
  box-sizing: border-box;
  padding: 0 10px;
}
.el-autocomplete {
  width: 100%;
}
.rightFileListContainer {
  height: 50%;
}
.timeLineContainer {
  height: 50%;

  .timeLineDataContainer {
    height: calc(100% - 33px);

    border-radius: 10px;
    background-color: #eee;

    .emptyFile {
      height: 100%;
      width: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      color: '#bebebe';

      div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;

        div {
          width: 100%;
        }

        img {
          width: 60%;
        }
      }
    }
  }
}
.logItemContainer {
  box-sizing: border-box;
  padding: 10px;
  height: 100%;
  overflow: auto;

  .logItem + .logItem {
    margin-top: 10px;
  }

  .logItemTitle {
    color: #000;

    display: flex;
    justify-content: space-between;
  }
  .logItemContent {
    color: #888;
  }
}
</style>
